import { render, staticRenderFns } from "./specCompEditor.vue?vue&type=template&id=25fdeb27"
import script from "./specCompEditor.vue?vue&type=script&lang=js"
export * from "./specCompEditor.vue?vue&type=script&lang=js"
import style0 from "./specCompEditor.vue?vue&type=style&index=0&id=25fdeb27&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports